module.exports = __webpack_public_path__ + "img/dungeon-fighter-online.63423d9f.png";